module.exports = __webpack_public_path__ + "1e1b7af103fe02ebc725ac8f063d83c1.png";